import { render, staticRenderFns } from "./ImgEditDialog.vue?vue&type=template&id=fbece2c8&scoped=true"
import script from "./ImgEditDialog.vue?vue&type=script&lang=js"
export * from "./ImgEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ImgEditDialog.vue?vue&type=style&index=0&id=fbece2c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbece2c8",
  null
  
)

export default component.exports